// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1ZD8W","title":"styles_title__7ufMr","buttonWrap":"styles_buttonWrap__chtg8","button":"styles_button__1uCV_"};